import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import './TicketBasicInformation.scss'
import BackLink from '../../../components/library/common/BackLink';
import { TicketState } from '../services/TicketState';
import { useSelector, useDispatch } from 'react-redux';
import Button from '../../../components/library/buttons/Button';
import { LaunchOutlined } from '@mui/icons-material';
import { Permissions } from '../../../app/services/Permissions';
import CloseTicketModal from './workflow/CloseTicketModal';
import { TaskStatus } from '../services/TaskStatus';
import ticketStateService from '../services/ticketState/TicketStateService';
import ticketService from '../services/manage/TicketService';
import TicketActions from '../../../store/ticketRedux';
import classnames from 'classnames';
import { supportsBlockPro } from 'strategies/TicketTypeStrategy';

const TicketLinks = (props) => {
    const { ticket, lang } = props;
    const ticketType = ticket ? ticket.ticketType.identifier.toUpperCase() : null;
    const canEditTicket = useSelector(state => (state.accountData.permissions || []).includes(Permissions.VIEW_MANAGE_TAB));
    const loggedInUserId = useSelector(state => (state.accountData?.employeeId));
    const [closeTicketDialogOpen, setCloseTicketDialogOpen] = useState(false);
    const [closeTicketError, setCloseTicketError] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const dispatch = useDispatch();
    
    const handleLaunchTPSCClick = () => {
        if (ticket.taxYear && ticket.viewModelId) {
            var windowUrl = window.location.href;
            var tpscUrl = windowUrl.includes("secure") ? localStorage.getItem('tpsc_base_uri_franchise') : localStorage.getItem('tps_base_uri')
            let myWindow = window.open();
            myWindow.location.href = tpscUrl + `/${ticket.taxYear}/return/${ticket.viewModelId}/clientid/interview/PRIMARY`;
        }
    }

    const showCloseTicketDialog = () => {
        setCloseTicketError(false);
        setCloseTicketDialogOpen(true)
    }

    const handleHideModal = () => {
        setCloseTicketDialogOpen(false);
        setCloseTicketError(false);
    }

    const handleCloseTicket = async (ticketStateIdentifier, reasonIdentifier) => {       
        var updatedTicket = await ticketStateService.updateTicketState(ticket, ticketStateIdentifier, reasonIdentifier);
        if (updatedTicket) {
            dispatch(TicketActions.setSelectedTicket(updatedTicket));
            setCloseTicketDialogOpen(false)
        } else {
            setCloseTicketError(true);
        }
    }

    const reopenTicket = async () => {
        try {
            setInProgress(true);
            var reopenedTicket = await ticketService.openAndAssignTicket(ticket.id, ticket.associateId);
            if (reopenedTicket) {
                dispatch(TicketActions.setSelectedTicket(reopenedTicket));
            }
        } catch (error) {
            console.log(error)
        } finally {
            setInProgress(false);
        }
        
    }

    const determineOffset = () => {
        const isTicketClosed = ticket && ticket.ticketState.identifier === TicketState.CLOSED;
        const isAssociateIdNotLoggedInUser = !canEditTicket && (ticket?.associateId != loggedInUserId);
      
        if (isTicketClosed || isAssociateIdNotLoggedInUser) {
          return (lang.toUpperCase() === 'EN') ? 'is-offset-8' : 'is-offset-7';
        } else {
          return (lang.toUpperCase() === 'EN') ? 'is-offset-6' : 'is-offset-5';
        }
      }

    return (
        <Fragment>
            <div className='columns tickets'>
                <div className='column is-2'>
                    <BackLink />
                </div>
                <div className={classnames('column is-3 launch-tpsc', determineOffset())} >
                    {ticket && ticket.taxYear && ticket.viewModelId !== 0 && supportsBlockPro(ticket.ticketType?.identifier) &&
                        <Button 
                            elementId='ticket-launchtpsc-btn' 
                            labelKey='Tickets.LaunchTPSC.LaunchBtn' 
                            buttonStyles='secondary' 
                            disabled={false} 
                            onClick={handleLaunchTPSCClick}>
                            <LaunchOutlined id='launch-tpsc-icon'/>
                        </Button>
                    }
                </div>
                {ticket && ticket.ticketState.identifier === TicketState.OPEN && (canEditTicket || (ticket.associateId === loggedInUserId)) &&
                    <div className='column is-2 close-reopen-btn'>
                        <Button
                            elementId='ticket-close-btn'
                            labelKey='Tickets.CloseTicket.CloseBtn'
                            buttonStyles='tertiary'
                            disabled={!ticket}
                            onClick={showCloseTicketDialog} /> 
                    </div>
                }
                {ticket && (ticket.ticketState.identifier === TicketState.CLOSED_COMPLETED_IN_OFFICE || ticket.ticketState.identifier === TicketState.CLOSED_INCOMPLETE) && (canEditTicket || (ticket.associateId === loggedInUserId)) &&
                    <div className='column is-2 close-reopen-btn'>
                        <Button
                            elementId='ticket-reopen-btn'
                            labelKey='Tickets.ReopenTicket.ReopenBtn'
                            buttonStyles='quaternary'
                            disabled={!ticket}
                            onClick={reopenTicket}
                            loading={inProgress} />
                    </div>
                }
            </div>
            <div className='columns tickets level separator-border'>
                <div className='column is-12'>
                    <hr/>
                </div>
            </div>
            <CloseTicketModal
                isOpen={closeTicketDialogOpen} status={closeTicketError ? TaskStatus.ERROR : TaskStatus.IN_PROGRESS} onCancel={handleHideModal}
                onCloseTicket={handleCloseTicket} updateFailed={closeTicketError} ticketType={ticketType} />
        </Fragment>
    );
}

TicketLinks.whyDidYouRender = false;

TicketLinks.propTypes = {
    ticket: PropTypes.object,
    lang: PropTypes.string
}

export default TicketLinks